/* ============
 * Mutation types for the unit-types module
 * ============
 *
 * The mutation types that are available
 * on the unit-types module.
 */

export const LOAD = 'LOAD';
export const ADD = 'ADD';
export const CLEAR = 'CLEAR';

export default {
  LOAD,
  ADD,
  CLEAR,
};
